import BackButton from '../../components/BackButton/BackButton';
import Footer from '../../components/Footer/Footer';
import NavHeaders from '../../components/NavHeaders/NavHeaders';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import SellerSection from '../../components/SellerSection/SellerSection';
import './Seller.css';

const Seller = () => {
    return(
        <>
            <NavHeaders/>
            <div className="seller-cancel-button">
                <BackButton text="Batalkan" goBack="false"/>
            </div>
            <SellerSection/>
            <Footer/>
        </>
    )
};

export default Seller;